// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 366) return "static/css/366.1f94a0116067c7784c23.lib.css";
	if (chunkId === 893) return "static/css/893.a3710005e36dbba136d5.css";
	// return url for filenames based on template
	return undefined;
};